import { createContext, useContext, useState, useCallback } from 'react';
import { toast } from 'sonner';

const CompareContext = createContext();

const MAX_COMPARE_ITEMS = 3;

export function CompareProvider({ children }) {
  const [compareItems, setCompareItems] = useState([]);

  const addToCompare = useCallback((product) => {
    setCompareItems(prev => {
      // Vérifier si déjà dans la liste
      if (prev.some(p => p.id === product.id)) {
        toast.info('Produit déjà dans la comparaison');
        return prev;
      }

      // Vérifier la limite
      if (prev.length >= MAX_COMPARE_ITEMS) {
        toast.warning(`Maximum ${MAX_COMPARE_ITEMS} produits à comparer`);
        return prev;
      }

      toast.success('Produit ajouté à la comparaison');
      return [...prev, product];
    });
  }, []);

  const removeFromCompare = useCallback((productId) => {
    setCompareItems(prev => prev.filter(p => p.id !== productId));
  }, []);

  const clearCompare = useCallback(() => {
    setCompareItems([]);
  }, []);

  const isInCompare = useCallback((productId) => {
    return compareItems.some(p => p.id === productId);
  }, [compareItems]);

  const value = {
    compareItems,
    addToCompare,
    removeFromCompare,
    clearCompare,
    isInCompare,
    compareCount: compareItems.length,
    canAddMore: compareItems.length < MAX_COMPARE_ITEMS,
  };

  return (
    <CompareContext.Provider value={value}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within a CompareProvider');
  }
  return context;
}

export default CompareContext;
